<template>
  <div class="container-fluid">
    <TableControls @searchterm="filterOffers($event)" :canSearch="true"/>
    <BaseTable
      :columns="columns"
      :tableData="offers"
      :pagination="pagination"
      :paginationParams="index"
      :indexCallback="getOffers"
    >
      <span slot="name" slot-scope="{row}">
        <router-link :to="`/offers/edit/${row.uuid}`">{{row.name}}</router-link>
      </span>
      <span slot="edited_by" slot-scope="{row}">
        {{ row.first_name }} {{ row.last_name }}
      </span>
      <span slot="delete" slot-scope="{row}">
        <i class="fas fa-trash-alt pointer" @click="showDeleteModal(row)"></i>
      </span>
      <span slot="duplicate" slot-scope="{row}">
        <i class="fas fa-copy pointer" @click="showDuplicateModal(row)"></i>
      </span>
    </BaseTable>
    <Modal v-if="show" @close="show = false">
      <h3 slot="header">Offer {{modalInformation.name}}</h3>
      <p slot="body">Are you sure you want to delete this Offer?</p>
      <div slot="footer">
        <button class="blueBtn smBtn" @click="deleteOffer(modalInformation)">Delete</button>
        <button class="greyBtn smBtn ml-1" @click="show = false">Cancel</button>
      </div>
    </Modal>
      <Modal v-if="duplicateModal" @close="showModal = false">
    <h3 slot="header">Duplicate Offer</h3>
    <div slot="body">
        <div class="form-group">
        <label for="duplicate">Create a New Offer Name</label><small> (Name must be unique)</small>
        <input type="text" class="form-control" id="duplicateSetName" v-model="duplicateName">
      </div>
    </div>
    <div slot="footer">
      <button class="greyBtn smBtn mr-1" @click="duplicateModal = false">Cancel</button>
      <button class="blueBtn smBtn ml-1" @click="duplicateOffer">Duplicate</button>
    </div>
  </Modal>
  </div>
</template>
<script>
import Offers from '@/resources/Offers.js'
export default {
  data () {
    return {
      show: false,
      duplicateModal: false,
      duplicateName: '',
      modalInformation: {},
      columns: [
        { name: 'Offer Name', key: 'name', class: 'col-md-3' },
        { name: 'Date Modified*', key: 'updated_at', class: 'col-md-4', filter: 'date' },
        { name: 'Modified By', key: 'edited_by', class: 'col-md-3' },
        { name: 'Delete', key: 'delete', class: 'col-md-1 text-center' },
        { name: 'Duplicate', key: 'duplicate', class: 'col-md-1 text-center' }
      ],
      offers: [],
      clone: {},
      params: '',
      index: {
        limit: 10,
        page: 1,
        total: null
      },
      pagination: {}
    }
  },
  mounted () {
    this.getOffers()
  },
  methods: {
    filterOffers (term) {
      Offers.filter(term).then(res => {
        if (res.error) {
          this.getOffers()
        } else {
          this.pagination = res
          this.offers = res.data
        }
      })
    },
    getOffers () {
      const index = this.index
      Offers.index(index).then(res => {
        this.offers = res.data
        this.pagination = res
      })
    },
    deleteOffer (offer) {
      const id = offer.uuid
      Offers.destroy(id).then(res => {
        this.show = false
        this.$toast('Offer succesfully deleted')
        this.getOffers()
      })
    },
    duplicateOffer () {
      const itemsToDeleteFromOffer = ['updated_at', 'created_at', 'deleted_at', 'edited_by', 'uuid']
      Offers.show(this.clone.uuid).then(res => {
        itemsToDeleteFromOffer.forEach(itemsBeingDeleted => delete res[itemsBeingDeleted])
        let offerToBeCloned = res
        return offerToBeCloned
      }).then(newOffer => {
        newOffer.name = this.duplicateName
        Offers.create(this.prepareOffer(newOffer)).then(res => {
          if (res.error && res.status === 422) {
            this.$toast(`Offer could not be Duplicated.`)
          } else {
            this.$toast(`Offerd Duplicated Successfuly.`)
            this.duplicateModal = false
            this.getOffers()
          }
        })
      })
    },
    showDuplicateModal (offer) {
      this.clone = offer
      this.duplicateModal = true
    },
    prepareOffer (offer) {
      let newOffer = { name: offer.name, attributes: [] }
      offer = JSON.parse(JSON.stringify(offer))
      delete offer.name
      for (var item in offer) {
        newOffer.attributes.push({ attribute: item, value: offer[item] })
      }
      return newOffer
    },
    showDeleteModal (offer) {
      this.modalInformation = offer
      this.show = true
    }
  },
  computed: {},
  components: {}
}
</script>
<style lang="scss" scoped>
</style>
